import React from "react";
import { useTranslation } from "react-i18next";

const Counter = ({ count, setcount }) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-72 border border-primary rounded-md my-2">
      <div className="flex bg-primary justify-center items-center p-2 w-32">
        <div className="text-white font-normal text-sm">
          {t("detail.count")}
        </div>
      </div>
      <div className="flex w-16 items-center">
        <div className="flex w-16 justify-center items-center font-medium text-xl">
          {count}
        </div>
      </div>
      <div className="flex w-24 items-center bg-primary">
        <div
          onClick={() => setcount((prev) => (prev > 1 ? prev - 1 : 1))}
          className="flex w-1/2 justify-center items-center text-white text-base p-0.5 hover:cursor-pointer"
        >
          -
        </div>
        <div
          onClick={() => setcount((prev) => prev + 1)}
          className="flex w-1/2 justify-center items-center text-white text-base p-0.5 hover:cursor-pointer"
        >
          +
        </div>
      </div>
    </div>
  );
  return (
    <div className="flex max-w-64 mt-2">
      <div className="flex w-32 justify-center items-center bg-primary border text-wrap rounded-l-md p-2 text-white text-sm">
        {t("detail.count")}
      </div>
      <div className="flex w-32 justify-center items-center bg-white border-primary border-2 text-wrap rounded-r-md p-2 text-primary text-sm">
        <div>{count}</div>
      </div>
    </div>
  );
};

export default Counter;
